'use strict';

import Vue from 'vue';
import { ENTITY_TYPES } from '@/helpers/entity-type.helper';

Vue.filter('getEntityTypeIdFromText', function (value) {
  return ENTITY_TYPES[value].id;
});
